import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { connectionRows, IssueTypeListDocument, type IssueTypeOption } from "#app/lib/data";

// Always-on workspace issue types — used by the list view's group labels so
// "Group by Project Type" shows every type regardless of whether the
// ungrouped data query has run.
export function useIssueTypes(): IssueTypeOption[] {
  const { data } = useQuery(IssueTypeListDocument);
  return useMemo(() => connectionRows(data?.issueTypes), [data]);
}
